import { createRouter, createWebHashHistory } from "vue-router";
import HomePage from "../HomePage.vue";
import QuickPick from "../QuickPick.vue";
import Result3D from "@/Result3D.vue";
import Result4D from "@/Result4D.vue";
import Result5D from "@/Result5D.vue";
import Schedule from "@/Schedule.vue";
import ClaimPage from "@/ClaimPage.vue";
import AboutPage from "@/About.vue";
import CekPage from "@/CekPage.vue";
import Statistic from "@/Statistic.vue";

const routes = [
  { path: "/", component: HomePage },
  { path: "/quickpick", component: QuickPick },
  { path: "/3d_result", component: Result3D },
  { path: "/4d_result", component: Result4D },
  { path: "/5d_result", component: Result5D },
  { path: "/schedule", component: Schedule },
  { path: "/claim", component: ClaimPage },
  { path: "/about", component: AboutPage },
  { path: "/cek", component: CekPage },
  { path: "/statistics", component: Statistic },
];

const router = createRouter({
  history: createWebHashHistory(),  routes,
  scrollBehavior() {
    // Always scroll to top on route change
    return { top: 0 };
  },
});

export default router;
